export const OTP_LENGTH = 6

/**
 * Dígitos do código num texto colado. Se houver 6 dígitos seguidos (ex.:
 * "Código OTP: 923926. Este é..."), usa só eles e ignora data e hora da
 * mensagem; senão, todos os dígitos do texto.
 */
export const extractOtpDigits = (raw: string): string => {
  const text = String(raw ?? "")
  const run = text.match(new RegExp(`(?:^|\\D)(\\d{${OTP_LENGTH}})(?!\\d)`))
  if (run) return run[1]
  return text.replace(/\D/g, "").slice(0, OTP_LENGTH)
}

/**
 * Coloca os dígitos nos quadrados. Código inteiro: do primeiro ao último,
 * venha de qual quadrado vier. Parte do código: a partir do quadrado atual.
 * `focus` é o quadrado que deve receber o foco depois.
 */
export const fillOtpDigits = (
  current: string[],
  index: number,
  digits: string,
): { otp: string[]; focus: number } => {
  if (digits.length >= OTP_LENGTH) {
    return {
      otp: digits.slice(0, OTP_LENGTH).split(""),
      focus: OTP_LENGTH - 1,
    }
  }

  const otp = [...current]
  let last = index
  digits.split("").forEach((d, i) => {
    const at = index + i
    if (at < OTP_LENGTH) {
      otp[at] = d
      last = at
    }
  })

  return { otp, focus: Math.min(last + 1, OTP_LENGTH - 1) }
}

/**
 * O que foi digitado ou inserido num quadrado (onChange), sem o dígito que já
 * estava nele. Teclado do celular e preenchimento automático inserem o código
 * inteiro de uma vez, sem disparar o evento de colar.
 */
export const otpInputDigits = (previous: string, value: string): string => {
  const digits = String(value ?? "").replace(/\D/g, "")
  if (!previous || digits.length <= 1) return digits

  if (digits.startsWith(previous)) return digits.slice(previous.length)
  if (digits.endsWith(previous)) return digits.slice(0, -previous.length)
  return digits
}
